// CUSTOM JS TO APPLY ONLY TO PRODUCT PAGE
$(function(){
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0540/2037/4702/files/left.png?v=1620197797" class="slide-arrow prev-arrow">',
        nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0540/2037/4702/files/brown.png?v=1620197797" class="slide-arrow next-arrow">',
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        centerMode: true,
        arrows: false,
        focusOnSelect: true,
        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 3
            }
      
        }]
    });


    $('.slider-nav').on('mouseenter', '.slick-slide', function (e) {
        var $currTarget = $(e.currentTarget), 
        index = $currTarget.data('slick-index'),
        slickObj = $('.slider-for').slick('getSlick');
        slickObj.slickGoTo(index);    
    });
});